import {
    // FILE_UPLOAD,
    CREATE_EMPLOYEE,
    RETRIEVE_EMPLOYEE,
    RETRIEVESINGLE_EMPLOYEE,
    UPDATE_EMPLOYEE,
    DELETE_EMPLOYEE,
} from "./type";
import Employee from "../service/Employee";
export const create = (data) => async (dispatch) => {
    try {
        const res = await Employee.create(data);
        dispatch({
            type: CREATE_EMPLOYEE,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await Employee.fetchList(data);
        dispatch({
            type: RETRIEVE_EMPLOYEE,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveStats = (data) => async (dispatch) => {
    try {
        const res = await Employee.fetchStats(data);
        // dispatch({
        //     type: RETRIEVE_EMPLOYEE,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await Employee.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_EMPLOYEE,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await Employee.update(data);
        dispatch({
            type: UPDATE_EMPLOYEE,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await Employee.changeStatus(data);
//         dispatch({
//             type: UPDATE_EMPLOYEE,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await Employee.trash(data);
        dispatch({
            type: DELETE_EMPLOYEE,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};